import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { MENTOR, BRAND } from "@/constants/content";
import { HOME } from "@/constants/testIds";

const AbstractPortrait = () => (
  <div className="relative aspect-[4/5] rounded-3xl overflow-hidden glass-light border border-white/70 shadow-premium">
    {/* Layered abstract shapes replacing a photo */}
    <div
      aria-hidden
      className="absolute inset-0"
      style={{
        background:
          "radial-gradient(60% 60% at 30% 30%, rgba(16,185,129,0.35), transparent 60%), radial-gradient(50% 50% at 80% 90%, rgba(163,230,53,0.4), transparent 60%), linear-gradient(160deg, #ecfdf5, #ffffff)",
      }}
    />
    <div className="grain opacity-20" aria-hidden />

    {/* Monogram plate */}
    <div className="absolute inset-0 flex items-center justify-center">
      <div className="relative">
        <motion.div
          initial={{ scale: 0.9, opacity: 0 }}
          whileInView={{ scale: 1, opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="w-40 h-40 sm:w-56 sm:h-56 rounded-full glass-light shadow-premium border border-white/80 grid place-items-center relative"
        >
          <span
            className="font-display font-extrabold text-6xl sm:text-7xl gradient-text-emerald select-none"
            style={{ letterSpacing: "-0.05em" }}
          >
            MA
          </span>
        </motion.div>
        <motion.div
          aria-hidden
          className="absolute -inset-6 rounded-full border border-emerald-500/20"
          animate={{ rotate: 360 }}
          transition={{ duration: 30, repeat: Infinity, ease: "linear" }}
        />
      </div>
    </div>

    {/* Corner mono ticker */}
    <div className="absolute top-3 left-3 chip">Mentor · 2026</div>
    <div className="absolute bottom-3 right-3 chip-dark bg-black/40 border-white/20 text-white">
      <span className="live-dot" /> Mentoring live
    </div>
  </div>
);

const MeetMentor = () => (
  <section id="mentor" className="section-pad relative">
    <div className="container-x">
      <div className="grid gap-10 lg:grid-cols-[0.9fr_1.1fr] items-center">
        <AbstractPortrait />

        <div>
          <div className="chip">Meet Your Mentor</div>
          <h2 className="mt-3 font-display font-bold tracking-tight text-slate-900" style={{ fontSize: "clamp(2rem, 4vw, 3.25rem)" }}>
            {MENTOR.name}
          </h2>
          <div className="mt-3 flex flex-wrap gap-2">
            {MENTOR.roles.map((r) => (
              <span key={r} className="text-xs sm:text-sm px-3 py-1.5 rounded-full bg-slate-100 border border-slate-200 text-slate-700">
                {r}
              </span>
            ))}
          </div>

          <div className="mt-6 space-y-4 max-w-2xl">
            {MENTOR.bio.map((p, i) => (
              <motion.p
                key={i}
                initial={{ opacity: 0, y: 10 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.05 }}
                className="text-slate-600 leading-relaxed"
              >
                {p}
              </motion.p>
            ))}
          </div>

          <a
            href={BRAND.mentorBioUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={HOME.mentorBioLink}
            className="mt-7 inline-flex items-center gap-2 btn-ghost"
          >
            Read Mohammad Asim&apos;s Biography
            <ArrowUpRight className="w-4 h-4" />
          </a>
        </div>
      </div>
    </div>
  </section>
);

export default MeetMentor;
